import React, { useState, useRef, useEffect } from "react";
// import "codemirror/lib/codemirror.css";
import CodeMirror from "@uiw/react-codemirror";
import { okaidia } from "@uiw/codemirror-theme-okaidia";
import { undoDepth, redoDepth } from "@codemirror/commands";
import { linter, lintGutter, forEachDiagnostic } from "@codemirror/lint";
import prettier from "prettier/standalone";
import parserCss from "prettier/parser-postcss";

import { css } from "@codemirror/lang-css";
import { CSSLint } from "csslint";
import {geteDetailByID} from "../../services/apis"


const CssComponent = ({
  editor,
  setCSSCodeEditor,
  checkErrors,
  setcheckErrors,
  deckData,
  preferredCss,
  defaultActiveTab,
  setSelectedComp,
  setUndoAvailable,
  setRedoAvailable,
}) => {
  const [code, setCode] = useState("");
  const cssRef = useRef();

  var options = {
    lineNumbers: true,
    lineWrapping: true,
    // mode: "css",
    autoCloseTags: true,
    autoCloseBrackets: true,
    lineWrapping: true,
    styleActiveLine: true,
    smartIndent: true,
    indentWithTabs: true,
  };

  const handleErrors = (errorList, from, to) => {
    console.log(errorList.severity);
    let error =
      errorList.severity === "error"
        ? setcheckErrors({ ...checkErrors, css: true })
        : "";
  };

  useEffect(() => {
    if (!cssRef.current.view) return;
    forEachDiagnostic(cssRef.current?.view?.viewState?.state, handleErrors);
    
    const undoDepthCount = undoDepth(cssRef.current?.view?.state);
    setUndoAvailable(undoDepthCount>0);
    const redoDepthCount = redoDepth(cssRef.current?.view?.state);
    setRedoAvailable(redoDepthCount>0);
  }, [code]);

 
  useEffect(()=>{
    if(defaultActiveTab !== "CSS") {
      setCode("");
    } else {
      let FormattedCode = prettier.formatWithCursor(editor?.getCss(), {
        parser: "css",
        plugins: [parserCss],
        tabWidth: 4,
        useTabs: false,
        //cursorOffset: editor.indexFromPos(editor.getCursor()),
      });
      setCode(FormattedCode.formatted);
      setCSSCodeEditor(cssRef);
  }
  },[defaultActiveTab]);
 
  
  
  //   e.stopImmediatePropagation();
  //   e.preventDefault();
  //   return;
  //   debugger
  //   console.log('Paste action disabled');
  // });
  editor?.on("component:selected", (component) => { 
    if(preferredCss !== 'Global'){
    
   let cssString = ""
    cssString= editor?.Css.getRule(`#${component.ccid}`)?.toCSS()||""
    let rules = component.getClasses();
    rules.forEach(rule =>{
      cssString= cssString+(editor?.Css.getRule(`.${rule}`)?.toCSS() ?editor?.Css.getRule(`.${rule}`)?.toCSS():"");
    })
    
    let FormattedCode = prettier.formatWithCursor(cssString, {
      parser: "css",
      plugins: [parserCss],
      tabWidth: 4,
      useTabs: false,
      //cursorOffset: editor.indexFromPos(editor.getCursor()),
    });
    setCode(FormattedCode.formatted);
    setCSSCodeEditor(cssRef);
    setSelectedComp(component.get("type")||"")  
  //   setCode(cssString)
  //  setCSSCodeEditor(cssString)
    }
}) 
  const updatedDeckData = ()=>{
   
    geteDetailByID(deckData._id, (res, err) => {
      if (err) {
      } else {
        const {data} = res;
        //if(data?.deck_shared_assets?.global){
          const cssString = data?.deck_shared_assets?.global?.css?.url ? data?.deck_shared_assets?.global?.css?.content : ' '; 
          let FormattedCode = prettier.formatWithCursor(cssString, {
            parser: "css",
            plugins: [parserCss],
            tabWidth: 4,
            useTabs: false,
            //cursorOffset: editor.indexFromPos(editor.getCursor()),
            });
          setCode(FormattedCode.formatted);
          setCSSCodeEditor(cssRef);
        //}
      }
    });
  }

  useEffect(() => {
    if(preferredCss === 'Global'){
      setCode('Loading Content....')
      updatedDeckData();
      }else{
        let FormattedCode = prettier.formatWithCursor(editor?.getCss(), {
          parser: "css",
          plugins: [parserCss],
          tabWidth: 4,
          useTabs: false,
          //cursorOffset: editor.indexFromPos(editor.getCursor()),
        });
        setCode(FormattedCode.formatted);
        setCSSCodeEditor(cssRef);
      }
    
  }, [preferredCss]);

  const setWrapperReadOnly = (cssRef) => {
    //word.markText({line:1,ch:1},{line:3,ch:1},{readOnly:true});
    // let Line =
    // cssRef.current.view.viewState.state.doc.line(message.line).from +
    // message.col;
    // cssRef.markText({ line: 1, ch: 1 }, { line: 3, ch: 1 }, { readOnly: true });
  };
  const checkForIDPosition = (
    indexofWord,
    arrLength,
    newString,
    word,
    resultIndex
  ) => {
    if (
      newString[indexofWord + arrLength] === " " ||
      newString[indexofWord + arrLength] === "{"
    ) {
      resultIndex.push(indexofWord);
      return resultIndex;
    } else {
      let newIndex = newString.indexOf(word, indexofWord + arrLength);
      if (newIndex === -1) return;
      checkForIDPosition(newIndex, arrLength, newString, word, resultIndex);
    }
  };
  const checkForDuplicateID = (dataString) => {
    let AllID = [];
    findID(dataString, AllID);
    let findDuplicatesID = (AllID) =>
      AllID.filter((item, index) => AllID.indexOf(item) != index);
    let UniqueDuplicatesID = [...new Set(findDuplicatesID(AllID))];
    let resultIndex = [];
    let errorLIst = [];
    UniqueDuplicatesID.forEach((arr) => {
      let newDataString = dataString.replaceAll("\n", " ");
      // console.log(newDataString, "newDataString");
      let findSubstringIndex = dataString.indexOf(arr);
      // console.log(
      //   dataString[findSubstringIndex + arr.length],
      //   "findSubstringIndex"
      // );
      newDataString.split(" ").forEach((word) => {
        if (arr === word) {
          let indexofWord = newDataString.indexOf(word);

          checkForIDPosition(
            indexofWord,
            arr.length,
            newDataString,
            arr,
            resultIndex
          );
        }
      });
    });
    let UniqueChar = [...new Set(findDuplicatesID(resultIndex))];
    UniqueChar.forEach((val) => {
      errorLIst.push({
        from: val,
        to: val,
        severity: "error",
        message: "Duplicate ID's are not Allowed",
      });
    });
    return errorLIst;
  };
  const findID = (dataString, AllID) => {
    if (dataString.indexOf("#") === -1 || dataString === "") return [...AllID];
    else if (dataString.indexOf("#")) {
      let foundIndexofHash = dataString.indexOf("#");
      let slicedDataString = "";
      let newFoundIndexofHash = "";
      if (foundIndexofHash) {
        slicedDataString = dataString.slice(foundIndexofHash);
        newFoundIndexofHash = slicedDataString.indexOf("#");
        let foundIndexofBracket = slicedDataString.indexOf("{") || 4; // on a guess that ID can be in length of 4

        let ID = slicedDataString
          .slice(newFoundIndexofHash, foundIndexofBracket)
          .trim();
        let foundIndexofCloseBracket = slicedDataString.indexOf("}");

        if (ID) {
          AllID.push(ID);
        }

        findID(slicedDataString.slice(foundIndexofCloseBracket), AllID);
      }
    }
  };
  const cssLinterExtension = linter((view) => {
    var errorList = [];
    let isIdExist =
      checkForDuplicateID(cssRef.current.view.viewState.state.doc.toString()) ||
      [];

    var messages =
      CSSLint.verify(cssRef.current.view.viewState.state.doc.toString()) || [];

    messages.messages.forEach((message) => {
      let Line =
        cssRef.current.view.viewState.state.doc.line(message.line).from +
        message.col;
      let charLocation = cssRef.current.view.viewState.state.doc.lineAt(Line);
      errorList.push({
        from: charLocation.from,
        to: charLocation.from,
        message: message.message,
        severity: message.type,
      });
    });
    setWrapperReadOnly(cssRef);
    return [...errorList, ...isIdExist];
  }, {});
  return (
    <div>
      <CodeMirror
        height="calc(100vh - 173px)"
        ref={cssRef}
        value={code}
        extensions={[css(), lintGutter(), cssLinterExtension]}
        theme={okaidia}
        // onBeforeChange={(editor, data, code) => {
        //   setCode({ code });
        // }}
        onChange={(updatedCode) => {
          setCode(updatedCode);
        }}
        options={options}
      />
    </div>
  );
};
export default CssComponent;
